import { render, staticRenderFns } from "./IssuePurchasedItemDetail.vue?vue&type=template&id=32c85958&scoped=true"
import script from "./IssuePurchasedItemDetail.vue?vue&type=script&lang=js"
export * from "./IssuePurchasedItemDetail.vue?vue&type=script&lang=js"
import style0 from "./IssuePurchasedItemDetail.vue?vue&type=style&index=0&id=32c85958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c85958",
  null
  
)

export default component.exports